import axios from "axios";
import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import PrivateRoute from "./app/components/PrivateRoute";
import Page404 from "./app/screens/404";
import Annulment from "./app/screens/Admin/Annulment";
import CreateLPN from "./app/screens/Admin/CreateLPN";
import Evidences from "./app/screens/Admin/Evidences";
import Operators from "./app/screens/Admin/Operators";
import Profiles from "./app/screens/Admin/Profiles";
import QueryLPN from "./app/screens/Admin/QueryLPN";
import ReceptionAdmin from "./app/screens/Admin/ReceptionAdmin";
import Returns from "./app/screens/Admin/Returns";
import Ubications from "./app/screens/Admin/Ubications";
import Users from "./app/screens/Admin/Users";
import Emails from "./app/screens/Admin/Emails";
import Login from "./app/screens/Login";
import Delivery from "./app/screens/Provider/Delivery";
import DeliveryDetail from "./app/screens/Provider/DeliveryDetail";
import Home from "./app/screens/Provider/Home";
import Query from "./app/screens/Provider/Query";
import Reception from "./app/screens/Provider/Reception";
import ReceptionDetail from "./app/screens/Provider/ReceptionDetail";
import ReceptionSummary from "./app/screens/Provider/ReceptionSummary";
import Reubication from "./app/screens/Provider/Reubication";
import ReubicationDetail from "./app/screens/Provider/ReubicationDetail";
import AuthUtils from "./app/utils/Auth";
import environment from "./app/environments/environment";
import Return from "./app/screens/Return/Home";
import ReturnReception from "./app/screens/Return/Recepcion";
import ReturnReceptionDetail from "./app/screens/Return/ReceptionDetail";
import ReturnReceptionSummary from "./app/screens/Return/ReceptionSummary";
import Calendar from "./app/screens/Return/Calendar";

axios.interceptors.request.use(
  (config) => {
    // if(config.url.includes('simple.ripley')) return config
    const userData = JSON.parse(localStorage.getItem("userappret"));
    if (userData) {
      config.headers["Authorization"] = `Bearer ${userData.token}`;
    }
    config.headers["x-api-key"] = environment.api.x_api_key;
    return config;
  },
  (error) => Promise.reject(error)
);

class Routes extends React.Component {
  render = () => (
    <Router>
      <Switch>
        <Route path="/login" exact>
          <Login />
        </Route>
        <Route path="/" exact>
          {AuthUtils.isAuthenticated() ? (
            AuthUtils.redirectToRoleHome()
          ) : (
            <Redirect to="/login" />
          )}
        </Route>
        <Route path="/admin" exact>
          {AuthUtils.isAuthenticated() ? (
            AuthUtils.redirectToRoleHome()
          ) : (
            <Redirect to="/login" />
          )}
        </Route>
        <PrivateRoute
          path="/home"
          exact
          requiredRoles={[
            AuthUtils.userRoles["carrier"],
            AuthUtils.userRoles["pickuppointop"],
          ]}
        >
          <Home />
        </PrivateRoute>
        <PrivateRoute
          path="/recepcion"
          exact
          requiredRoles={[AuthUtils.userRoles["carrier"]]}
        >
          <Reception />
        </PrivateRoute>
        <PrivateRoute
          path="/recepcion/resumen"
          exact
          requiredRoles={[AuthUtils.userRoles["carrier"]]}
        >
          <ReceptionSummary />
        </PrivateRoute>
        <PrivateRoute
          path="/consulta"
          exact
          requiredRoles={[
            AuthUtils.userRoles["carrier"],
            AuthUtils.userRoles["pickuppointop"],
          ]}
        >
          <Query />
        </PrivateRoute>
        <PrivateRoute
          path="/recepcion/:id"
          exact
          requiredRoles={[AuthUtils.userRoles["carrier"]]}
        >
          <ReceptionDetail />
        </PrivateRoute>
        <PrivateRoute
          path="/entrega"
          exact
          requiredRoles={[AuthUtils.userRoles["pickuppointop"]]}
        >
          <Delivery />
        </PrivateRoute>
        <PrivateRoute
          path="/entrega/:id"
          exact
          requiredRoles={[AuthUtils.userRoles["pickuppointop"]]}
        >
          <DeliveryDetail />
        </PrivateRoute>
        <PrivateRoute
          path="/reubicacion"
          exact
          requiredRoles={[AuthUtils.userRoles["carrier"]]}
        >
          <Reubication />
        </PrivateRoute>
        <PrivateRoute
          path="/reubicacion/:id"
          exact
          requiredRoles={[AuthUtils.userRoles["carrier"]]}
        >
          <ReubicationDetail />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/operadores-retiro"
          exact
          requiredRoles={[AuthUtils.userRoles["admin"]]}
        >
          <Operators />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/puntos-retiro"
          exact
          requiredRoles={[AuthUtils.userRoles["admin"]]}
        >
          <Ubications />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/perfiles"
          exact
          requiredRoles={[AuthUtils.userRoles["admin"]]}
        >
          <Profiles />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/usuarios"
          exact
          requiredRoles={[AuthUtils.userRoles["admin"]]}
        >
          <Users />
        </PrivateRoute>

        <PrivateRoute
          path="/admin/recepcion"
          exact
          requiredRoles={[
            // AuthUtils.userRoles['admin'],
            AuthUtils.userRoles["cdadmin"],
          ]}
        >
          <ReceptionAdmin />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/devoluciones"
          exact
          requiredRoles={[
            // AuthUtils.userRoles['admin'],
            AuthUtils.userRoles["cdadmin"],
          ]}
        >
          <Returns />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/crearLPN"
          exact
          requiredRoles={[AuthUtils.userRoles["mkp"]]}
        >
          <CreateLPN />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/consultarLPN"
          exact
          requiredRoles={[
            AuthUtils.userRoles["mkp"],
            AuthUtils.userRoles["seller"],
          ]}
        >
          <QueryLPN />
        </PrivateRoute>

        <PrivateRoute
          path="/admin/solicitud-evidencias"
          exact
          requiredRoles={[AuthUtils.userRoles["backoffice"]]}
        >
          <Evidences />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/reenviar-correo"
          exact
          requiredRoles={[AuthUtils.userRoles["backoffice"]]}
        >
          <Emails />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/reenviar-correo"
          exact
          requiredRoles={[AuthUtils.userRoles["admin"]]}
        >
          <Emails />
        </PrivateRoute>
        <PrivateRoute
          path="/admin/anulacion-cuds"
          exact
          requiredRoles={[AuthUtils.userRoles["backoffice"]]}
        >
          <Annulment />
        </PrivateRoute>

        <PrivateRoute
          path="/return"
          exact
          requiredRoles={[AuthUtils.userRoles["RecepcionCD"]]}
        >
          <Return />
        </PrivateRoute>

        <PrivateRoute
          path="/return-recepcion"
          exact
          requiredRoles={[AuthUtils.userRoles["RecepcionCD"]]}
        >
          <ReturnReception />
        </PrivateRoute>
        <PrivateRoute
          path="/return-recepcion/resumen"
          exact
          requiredRoles={[AuthUtils.userRoles["RecepcionCD"]]}
        >
          <ReturnReceptionSummary />
        </PrivateRoute>
        <PrivateRoute
          path="/return-recepcion/:id"
          exact
          requiredRoles={[AuthUtils.userRoles["RecepcionCD"]]}
        >
          <ReturnReceptionDetail />
        </PrivateRoute>

        <Route path="/calendar" exact component={Calendar} />

        <Route>
          <Page404 />
        </Route>
      </Switch>
    </Router>
  );
}

export default Routes;
